/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PhaseWithContent } from '../../models/phase-with-content';
import { UpdatePhaseDto } from '../../models/update-phase-dto';

export interface PhaseControllerUpdate$Params {
  phaseId: string;
      body: UpdatePhaseDto
}

export function phaseControllerUpdate(http: HttpClient, rootUrl: string, params: PhaseControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PhaseWithContent>> {
  const rb = new RequestBuilder(rootUrl, phaseControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('phaseId', params.phaseId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PhaseWithContent>;
    })
  );
}

phaseControllerUpdate.PATH = '/phase/{phaseId}';
